import React from "react";
import { MarkerType } from "react-flow-renderer";

import { Link } from "react-router-dom";

const level1 = "rgb(17,3,3, 0.1)";
const level2 = "#5d1c53";
const level3 = "rgb(20,28,39, 0.9)";
const level4 = "#3c5475";
const level5 = "#4517d1";
const level6 = "#de723a";
const black = "yellow";
const white = "white";
const transparent = "00FFFFFF";
const spaceColor = "#141c26";

export const nodes = [
  {
    id: "1",
    type: "input",
    data: {
      label: (
        <>
          <strong>Pseudo-elements</strong>
          <p>
            A keyword added to a selector that lets you style a specific part of
            the selected element(s). <br /> <br /> Note: I only included the
            Pseudo-elemtns I felt were most relevant/important.
          </p>
        </>
      ),
    },
    position: { x: -408, y: 0 },
    style: {
      background: level1,
      color: black,
      border: "1px solid #222138",
      width: 1000,
    },
  },

  {
    id: "2",

    data: {
      label: (
        <>
          <strong>::after</strong>
          <p>
            Inserts something after the content of each selected element(s).
          </p>
          <iframe
            height="500"
            width="100%"
            scrolling="no"
            title=":has() with :not()"
            src="https://codepen.io/jonathanelias1/embed/preview/LYmjWqx?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/LYmjWqx">
              :has() with :not()
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -1338, y: 800 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 500,
    },
  },

  {
    id: "3",

    data: {
      label: (
        <>
          <strong>::before</strong>
          <p>
            Inserts something before the content of each selected element(s).
          </p>
          <iframe
            height="300"
            width="100%"
            scrolling="no"
            title="::after"
            src="https://codepen.io/jonathanelias1/embed/preview/RwyZpOj?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/RwyZpOj">::after</a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -1942, y: 800 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 500,
    },
  },

  {
    id: "4",

    data: {
      label: (
        <>
          <strong>::first-letter</strong>
          <p>
            Used to add a style to the first letter of the specified selector.
          </p>
          <p>Note: This selector can only be used with block-level elements.</p>

          <iframe
            height="500"
            width="100%"
            scrolling="no"
            title="::before"
            src="https://codepen.io/jonathanelias1/embed/preview/LYmjWKW?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/LYmjWKW">::before</a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 440, y: 800 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 500,
    },
  },

  {
    id: "5",

    data: {
      label: (
        <>
          <strong>::first-line</strong>
          <p>
            Used to add a style to the first line of the specified selector.
          </p>

          <iframe
            height="500"
            width="100%"
            scrolling="no"
            title="::first-letter"
            src="https://codepen.io/jonathanelias1/embed/preview/vYjJmYp?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/vYjJmYp">
              ::first-letter
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 1580, y: 800 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 500,
    },
  },

  {
    id: "6",

    data: {
      label: (
        <>
          <strong>::selection</strong>
          <p>
            Matches the portion of an element that is selected by a user.
            <br />
            <br />
            Only a few CSS properties can be applied to the ::selection
            selector: color, background, cursor, and outline.
          </p>

          <iframe
            height="500"
            width="100%"
            scrolling="no"
            title="::first-line"
            src="https://codepen.io/jonathanelias1/embed/preview/rNvzmOx?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/rNvzmOx">
              ::first-line
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 1028, y: 800 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 500,
    },
  },

  {
    id: "7",

    data: {
      label: (
        <>
          <strong>::marker</strong>
          <p>
            {" "}
            Selects the marker box of a list item, which typically contains a
            bullet or number. <br />
            <br /> It works on any element or pseudo-element set to display:
            list-item, such as the {`<li>`} and {`<summary>`} elements.
          </p>

          <iframe
            height="500"
            width="100%"
            scrolling="no"
            title="::first-line"
            src="https://codepen.io/jonathanelias1/embed/preview/mdLMmVL?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/mdLMmVL">
              ::first-line
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -160, y: 800 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 500,
    },
  },

  {
    id: "8",

    data: {
      label: (
        <>
          <strong>::placeholder</strong>
          <p>
            Represents the placeholder text in an {`<input>`} or {`<textarea>`}{" "}
            element.
          </p>
          <iframe
            height="500"
            width="100%"
            scrolling="no"
            title="::marker"
            src="https://codepen.io/jonathanelias1/embed/preview/bGMrWeZ?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/bGMrWeZ">::marker</a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -740, y: 800 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 500,
    },
  },

  // End of items
];

export const edges = [
  {
    id: "e1-2",
    source: "1",
    target: "2",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e1-3",
    source: "1",
    target: "3",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e1-4",
    source: "1",
    target: "4",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e1-5",
    source: "1",
    target: "5",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e1-6",
    source: "1",
    target: "6",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e1-7",
    source: "1",
    target: "7",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e1-8",
    source: "1",
    target: "8",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  //   {
  //     id: "e8-10",
  //     source: "8",
  //     target: "10",
  //     animated: true,
  //     style: { stroke: "#f6ab6c" },
  //     markerEnd: {
  //       type: MarkerType.ArrowClosed,
  //     },
  //   },

  //END
];
